import { Component, OnInit } from '@angular/core';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-dealer-report-search',
  templateUrl: './dealer-report-search.component.html',
  styleUrls: ['./dealer-report-search.component.scss']
})
export class DealerReportSearchComponent implements OnInit {

  profile: DealerProfile;

  constructor(
    private route: ActivatedRoute, private readonly router: Router
  ) {
  }

  ngOnInit() {
    this.route.data.subscribe(({ profile }) => {
      this.profile = profile;
      if(!this.profile.bulkDataReport) {
        this.router.navigate([`/dealer/report-log`]);
      }
    });
  }

}
